import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-33c7c61c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "num-statistics-warp"
};
const _hoisted_2 = {
  class: "top-count-statistics cms-card-block"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_5 = {
  class: "title-name"
};
const _hoisted_6 = {
  class: "total-count text-center"
};
const _hoisted_7 = {
  class: "bottom-count-statistics cms-card-block mg-b--15"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_10 = {
  class: "title-name"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "day-count"
};
const _hoisted_14 = {
  class: "item-count"
};
const _hoisted_15 = {
  class: "header"
};
const _hoisted_16 = {
  class: "count"
};
const _hoisted_17 = {
  class: "item-count"
};
const _hoisted_18 = {
  class: "header"
};
const _hoisted_19 = {
  class: "count"
};
const _hoisted_20 = {
  class: "month-count"
};
const _hoisted_21 = {
  class: "item-count"
};
const _hoisted_22 = {
  class: "header"
};
const _hoisted_23 = {
  class: "count"
};
const _hoisted_24 = {
  class: "item-count"
};
const _hoisted_25 = {
  class: "header"
};
const _hoisted_26 = {
  class: "count"
};
const _hoisted_27 = {
  class: "bottom-count-statistics cms-card-block mg-b--0"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_30 = {
  class: "title-name"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_32 = {
  class: "info"
};
const _hoisted_33 = {
  class: "all-count"
};
const _hoisted_34 = {
  class: "item-count"
};
const _hoisted_35 = {
  class: "header"
};
const _hoisted_36 = {
  class: "count"
};
const _hoisted_37 = {
  class: "item-count"
};
const _hoisted_38 = {
  class: "header"
};
const _hoisted_39 = {
  class: "count"
};
import { getTextWidth } from '@/utils';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'NumStatistics',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: {
        channelCount: 0,
        onLineList: []
      }
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const cloneData = ref({
      channelCount: 0,
      onLineList: [{
        onLine: 0,
        offLine: 0
      }, {
        onLine: 0,
        offLine: 0
      }, {
        onLine: 0,
        offLine: 0
      }]
    });
    const tooltipContent = ref(t('(电影总数 + 电视剧剧集总数)')); //  内容超出时显示提示

    const tipDisabled = ref(false);

    const showTextTip = (e, fontSize) => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: fontSize,
        fontWeight: 600
      });
      tipDisabled.value = target.offsetWidth > width;
    };

    watch(() => props.data, (newVal, oldVal) => {
      if (newVal) {
        cloneData.value.channelCount = newVal.channelCount;
        cloneData.value.onLineList = newVal.onLineList;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('频道总数')), 1)])]), _createElementVNode("div", _hoisted_6, _toDisplayString(cloneData.value.channelCount), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('操作统计')), 1), _createVNode(_component_el_tooltip, {
        effect: "light",
        "popper-class": "tps",
        content: _ctx.$t('为频道被操作的次数，例如频道被操作2次上线，数据即为2'),
        placement: "top"
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }, 8, ["content"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('昨日上线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[0] || (_cache[0] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('昨日上线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_16, _toDisplayString(cloneData.value.onLineList[0].onLine), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('昨日下线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[1] || (_cache[1] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('昨日下线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_19, _toDisplayString(cloneData.value.onLineList[0].offLine), 1)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('本月上线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[2] || (_cache[2] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('本月上线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_23, _toDisplayString(cloneData.value.onLineList[1].onLine), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('本月下线次数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[3] || (_cache[3] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('本月下线次数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_26, _toDisplayString(cloneData.value.onLineList[1].offLine), 1)])])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('频道统计')), 1), _createVNode(_component_el_tooltip, {
        effect: "light",
        "popper-class": "tps",
        content: _ctx.$t('为频道在平台上数据，以频道最终状态为统计结果，例如频道操作上线再操作下线，那么上线-1，下线+1。'),
        placement: "top"
      }, {
        default: _withCtx(() => [_hoisted_31]),
        _: 1
      }, 8, ["content"])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('上线频道总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[4] || (_cache[4] = $event => showTextTip($event, '0.729vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('上线频道总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_36, _toDisplayString(cloneData.value.onLineList[2].onLine), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createVNode(_component_el_tooltip, {
        disabled: tipDisabled.value,
        effect: "light",
        "popper-class": "self-popper",
        content: _ctx.$t('下线频道总数'),
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          onMouseover: _cache[5] || (_cache[5] = $event => showTextTip($event, '0.833vw')),
          class: "tooltip-item"
        }, _toDisplayString(_ctx.$t('下线频道总数')), 33)]),
        _: 1
      }, 8, ["disabled", "content"])]), _createElementVNode("div", _hoisted_39, _toDisplayString(cloneData.value.onLineList[2].offLine), 1)])])])])]);
    };
  }

});